import { useReviewDelete } from '@/module/Author/Review';

import { DeleteButton } from '@/core/components';

import { Id, useDelete } from '@feature/utils';

interface ReviewDeleteButtonProps {
  reviewId: Id;
}

export function ReviewDeleteButton({ reviewId }: ReviewDeleteButtonProps) {
  const mutation = useReviewDelete(reviewId);
  const deleteProps = useDelete({
    mutation,
    navigateTo: { to: '..' },
  });

  return (
    <DeleteButton
      miw="100px"
      size="xs"
      {...deleteProps}
    />
  );
}
